export const encodeToBase64 = (str: string): string => {
  const bytes = new TextEncoder().encode(str);
  let binary = '';
  for (let i = 0; i < bytes.length; i++) {
    binary += String.fromCharCode(bytes[i]);
  }
  return btoa(binary);
};

/**
 * The raw bytes, for content that is not text — an image or a font inside a custom asset
 * folder is corrupted by a round trip through `TextDecoder`.
 */
export const decodeBase64ToBytes = (str: string): Uint8Array => {
  const binary = atob(str);
  const bytes = new Uint8Array(binary.length);
  for (let i = 0; i < binary.length; i++) {
    bytes[i] = binary.charCodeAt(i);
  }
  return bytes;
};

export const decodeFromBase64 = (str: string): string =>
  new TextDecoder().decode(decodeBase64ToBytes(str));
